<!-- <span class="step">3</span>
<p class="block-full-width__title">
    {{'MEDIUM_STEP_CHOOSE_MEDIUM_TYPE_TITLE' | translate}}</p> -->

<!-- <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{step}}">{{step}}</span>
<h2 id="product_length_title" class="block-full-width__title">
    {{ 'MEDIUM_STEP_CHOOSE_MEDIUM_TYPE_TITLE' | uppercase | translate }}
</h2> -->


<ng-container *ngIf="!isEmpty">

    <ng-container *ngFor="let mediumGroup of (mediumGroups$ | async); let last=last">
        <div class="items-area">
            <div *ngIf="!last" [ngClass]="{'items-area__item or-blocks': (last !== true)}">
                <ridango-selectable-checkable-item [locale]="locale" [item]="mediumGroup"
                    [selected]="mediumGroup.type === (selectedMediumGroup$ | async)?.type"
                    (onItemSelected)="mediumTypeSelected($event)"></ridango-selectable-checkable-item>
            </div>

            <div *ngIf="last" [ngClass]="{'items-area__item or-blocks': (last === true)}">
                <ridango-selectable-checkable-item [locale]="locale" [item]="mediumGroup"
                    [selected]="mediumGroup.type  === (selectedMediumGroup$ | async)?.type"
                    (onItemSelected)="mediumTypeSelected($event)"></ridango-selectable-checkable-item>
            </div>

            <div class="items-area__item" *ngIf="!last">
                <ridango-vertical-or-separator>
                </ridango-vertical-or-separator>
            </div>
        </div>

    </ng-container>
</ng-container>
